/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Hero_To_PapersInputs */

const en_auth_hero_to_papers = /** @type {(inputs: Auth_Hero_To_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`to papers`)
};

const es_auth_hero_to_papers = /** @type {(inputs: Auth_Hero_To_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tus artículos`)
};

/**
* | output |
* | --- |
* | "to papers" |
*
* @param {Auth_Hero_To_PapersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_hero_to_papers = /** @type {((inputs?: Auth_Hero_To_PapersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Hero_To_PapersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_hero_to_papers(inputs)
	return en_auth_hero_to_papers(inputs)
});